import getCurrentOrganization from '@plug/helpers/get-current-organization';

export default function(): boolean {
  const currentOrganizationInfo = getCurrentOrganization();

  return currentOrganizationInfo?.organizationRole[0]?.name === 'ADMIN';
}
